<template>
  <div>

    <div role="tabpanel" class="tab-pane" id="gas">
      <form action="">
        <legend>Erdgas</legend>

        <h3>Finden Sie jetzt Ihren passenden Erdgastarif.</h3>

        <div class="row">
          <input type="hidden" v-model="zipcode" id="zipCode" name="zipCode" />
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Ihre Postleitzahl</label>
              <selectboxajax
                  id="citylabel"
                  name="citylabel"
                  v-model="citylabel"
                  class="border spacing-bottom-2 no-sod form-control"
                  data-no-result-msg="Keine Ergebnisse, <a href='/service-und-kontakt/kontaktformulare/strassenvorschlag/' title='Anfrage' target='_blank'>Anfrage</a>"
                  tabindex="1"
                  aria-required="true"
                  required
                  ajaxurl="/typo3conf/ext/hmmh_dew21_frontend/Resources/Public/Scripts/calculator/dist/parsejson.php"
                  onselect="checkcitylabel"
                  oncomplete="citylabelcomplete"
                  @checkcitylabel="citylabelcomplete(), checkForm($event), checkcitylabel($event)"
                  @citylabelcomplete="citylabelcomplete()"
                  :triggerpreselect="false"
                  autocomplete="off"
                  :disabled="isMaintenance == true"
              >
              </selectboxajax>

            </div>
          </div>
          
          <div id="isMultiaddress" class="select-street hidden" ><!-- v-if="isMultiaddress" -->

            <div class="row">
              <div class="col-md-3" id="citycodemd">
                <div class="form-group">
                  <selectbox
                      id="citycode"
                      name="citycode"
                      class="border spacing-bottom-2 no-sod form-control"
                      data-no-result-msg="Keine Ergebnisse, <a href='/service-und-kontakt/kontaktformulare/strassenvorschlag/' title='Anfrage' target='_blank'>Anfrage</a>"
                      :options="citycodes"
                      :value="citycode"
                      :hideSearch="true"
                      onchange="checkForm"
                      @checkForm="checkForm($event)"
                      tabindex="2"
                      autocomplete="off"
                  >
                  </selectbox>
                </div>
              </div>

              <div class="col-12 col-md-8 col-lg-4" v-show="this.citycodes.length == 1">
                <div class="form-group">
                  <selectbox
                      id="streetcode"
                      name="streetcode"
                      class="border spacing-bottom-2 no-sod form-control"
                      data-no-result-msg="Keine Ergebnisse, <a href='/service-und-kontakt/kontaktformulare/strassenvorschlag/' title='Anfrage' target='_blank'>Anfrage</a>"
                      tabindex="3"
                      aria-hidden="true"
                      :options="streetcodes"
                      :value="streetcode"
                      onchange="checkForm"
                      @checkForm="checkForm($event)"
                      autocomplete="off"
                  >
                  </selectbox>
                </div>
              </div>

              <div class="col-4 col-md-2 col-lg-2" v-show="this.citycodes.length == 1">
                <div class="form-group">
                  <input class="form-control" type="text" name="housenumber" id="housenumber" v-model="housenumber" v-on:change="checkForm" placeholder="Hausnr." tabindex="4" autocomplete="off" />
                </div>
              </div>

              <div class="col-4 col-md-2 col-lg-2" v-show="this.citycodes.length == 1">
                <div class="form-group">
                  <input class="form-control" type="text" name="housenumberextension" id="housenumberextension" v-model="housenumberextension" placeholder="Zusatz" v-on:change="checkForm" tabindex="5" autocomplete="off" />
                </div>
              </div>
            </div>
         </div>

          <div class="col-lg-4">
            <div class="form-group">
              <div class="seclect-household-container">
                <label for="">Größe Ihrer Wohnung</label>

                <div class="row">
                  <div class="col-auto">
                    <label for="50qm" class="select-household 50qm">
                      <input :disabled="isMaintenance == true" type="radio" checked="checked" name="consumptionpicker" id="50qm" value="5000" v-model="consumptionpicker" v-on:click="setConsumption" tabindex="6">
                      <span class="checkmark">50 m²</span>
                    </label>
                  </div>

                  <div class="col-auto">
                    <label for="100qm" class="select-household 100qm">
                      <input :disabled="isMaintenance == true" type="radio" name="consumptionpicker" id="100qm" v-model="consumptionpicker" value="12000" v-on:click="setConsumption" tabindex="7">
                      <span class="checkmark">100 m²</span>
                    </label>
                  </div>

                  <div class="col-auto">
                    <label for="150qm" class="select-household 150qm">
                      <input :disabled="isMaintenance == true" type="radio" name="consumptionpicker" id="150qm" v-model="consumptionpicker" value="18000" v-on:click="setConsumption" tabindex="8">
                      <span class="checkmark">150 m²</span>
                    </label>
                  </div>

                  <div class="col-auto">
                    <label for="180qm" class="select-household 180qm">
                      <input :disabled="isMaintenance == true" type="radio" name="consumptionpicker" id="180qm" v-model="consumptionpicker" value="21000" v-on:click="setConsumption" tabindex="9">
                      <span class="checkmark">180 m²</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>    
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Verbrauch pro Jahr</label>
              <input class="form-control" type="text" @focus="focusConsumption" v-model.number="consumptionlabel" id="consumptionlabel" name="consumptionlabel" :placeholder="defaultConsumption" v-on:keypress.enter="checkEnterConsumption" v-on:input="checkForm" tabindex="10" autocomplete="off" />
              <input type="hidden" :disabled="isMaintenance == true" v-model="consumption" id="consumption" name="consumption" />
            </div>
          </div>
        
        </div>

        <div id="msgcontainer"></div>

        <div v-if="isMaintenance == true && maintenanceMessage" class="form-group alert alert-warning alert-dismissible" v-html="maintenanceMessage"></div>

      <input type="submit" id="continueToDelivery" :maintenance="isMaintenance == true" class="btn-cta" v-on:click.prevent="continuetodelivery" value="Tarif finden" tabindex="11" :disabled="isMaintenance == true" />
      </form>
    </div>

  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import Selectbox from "@/components/Selectbox";
import Selectboxajax from "@/components/Selectboxajax";

var itemStr = window.localStorage.getItem('tarifrechnerStrom')
// if the item doesn't exist, return null
if (itemStr) {
  var item = JSON.parse(itemStr)
  var now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    localStorage.removeItem('tarifrechnerStrom')
    
  }
  itemStr = window.localStorage.getItem('tarifrechnerStrom');
}

let settings = {
  defaultConsumption: 'Ihr Erdgasverbrauch in kWh pro Jahr*',
  defaultZipcode: 'Postleitzahl*'
};


export default {
  props: {
    defaultSettings: Object,
    reassignInput: Object,
    maintenance: Object
  },
  data() {
    return {
      isMaintenance: this.maintenance.active,
      maintenanceMessage: decodeURIComponent(this.maintenance.message),
      settings: settings,
      defaultConsumption: settings.defaultConsumption,
      defaultZipcode: settings.defaultZipcode,
      consumptionpicker: '5000',
      consumption: '5000',
      consumptionlabel: '5000 kWh',
      zipcode: (this.itemStr ? JSON.parse(this.itemStr).value : ((this.defaultSettings.zipcode) ? this.defaultSettings.zipcode : '')),
      // citylabel: (itemStr ? JSON.parse(itemStr).value : ((this.defaultSettings.zipcode) ? this.defaultSettings.zipcode : '')),
      citycode: '',
      citycodes: [],
      streetcode: '',
      streetcodes: [],
      housenumber: '',
      housenumberextension: '',
      salesSource: ((this.defaultSettings.salesSource) ? this.defaultSettings.salesSource : ''),
      zipcodepos: (this.tarifrechnerStr ? JSON.parse(this.tarifrechnerStr).value.zipcodepos : 0 ),
      submitAllowed: false
    }
  },
  mounted() {
    if(typeof this.reassignInput.salesSource !== 'undefined') {
      this.salesSource = this.reassignInput.salesSource;
    }

    this.tarifrechnerkey = 'tarifrechnerStrom';
    var itemStr = window.localStorage.getItem(this.tarifrechnerkey)
// if the item doesn't exist, return null
    if (itemStr) {
      var item = JSON.parse(itemStr)
      var now = new Date()
      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        localStorage.removeItem(this.tarifrechnerkey)

      }
      itemStr = window.localStorage.getItem(this.tarifrechnerkey);

      this.zipcode = JSON.parse(itemStr).value;
      this.citylabel = JSON.parse(itemStr).value;
    }
    this.submitAllowed = true;

    var tarifrechnerStr = window.localStorage.getItem('tarifrechner');
// if the item doesn't exist, return null
    if (tarifrechnerStr) {
      var tarifrechneritem = JSON.parse(tarifrechnerStr)
      var nowti = new Date()
      // compare the expiry time of the item with the current time
      if (nowti.getTime() > tarifrechneritem.expiry) {
        // If the item is expired, delete the item from storage
        localStorage.removeItem('tarifrechner')

      }
      tarifrechnerStr = window.localStorage.getItem('tarifrechner');

      if(typeof tarifrechneritem.value != "undefined") this.zipcodepos = tarifrechneritem.value.zipcodepos;
    }

    var self = this;
    $(document).on('focus click tap', '#app input', function() {
      if($(this).attr("name") != 'consumptionlabel' && $(this).attr("type") == 'text') $(this).attr("name", 'field' + self.noCacheTimestamp());
    });

    // Fokus von PLZ wegnehmen
    $('#citylabel').on('select2:close', function(e) {
      $('input[type="radio"]:first').focus();

      self.zipcodeold = $('#' + e.target.id).val();
      self.zipcode = self.zipcodeold;
      self.streetcode = '';
      self.housenumber = '';
      self.housenumberextension = '';
      self.citycode = '';

      self.checkForm(e);
      self.checkcitylabel(e);
    });

    this.checkForm(null);
  },
  computed: {
    citylabel: function(){
      var returnval;

      var tarifrechnerkey = 'tarifrechnerStrom';
      var itemStr = window.localStorage.getItem(tarifrechnerkey)
// if the item doesn't exist, return null
      if (itemStr) {
        var item = JSON.parse(itemStr)
        var now = new Date()
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
          // If the item is expired, delete the item from storage
          localStorage.removeItem(tarifrechnerkey)

        }
        itemStr = window.localStorage.getItem(tarifrechnerkey);
      }

      var tarifrechnerStr = window.localStorage.getItem('tarifrechner');
// if the item doesn't exist, return null
      var zipcodepos = 0;
      if (tarifrechnerStr) {
        var tarifrechneritem = JSON.parse(tarifrechnerStr)
        var nowti = new Date()
        // compare the expiry time of the item with the current time
        if (nowti.getTime() > tarifrechneritem.expiry) {
          // If the item is expired, delete the item from storage
          localStorage.removeItem('tarifrechner')

        }
        tarifrechnerStr = window.localStorage.getItem('tarifrechner');

        if(typeof tarifrechneritem.value != "undefined") zipcodepos = tarifrechneritem.value.zipcodepos;
      }

      if(this.defaultSettings.zipcode) returnval = this.defaultSettings.zipcode;

      if(itemStr) returnval = JSON.parse(itemStr).value;

      if(zipcodepos != 0) returnval = 'pos' + zipcodepos;

      return returnval;
    }
  },
  methods: {
    focusConsumption: function() {
      this.consumptionlabel = '';
      this.consumption = '';
      this.$nextTick(() => {
        this.checkForm();
      });
    },
    checkEnterConsumption: function(e) {
      e.preventDefault();
      let that = this;
      this.$nextTick(() => {
        if(that.consumption > 10000 || that.consumption == 0 || that.consumption == "") {
          return false;
        }
        else {
          that.continuetodelivery();
        }
      });
    },
    checkForm: function(event) {
      if(event) {
        var citylabelval = $('#citylabel').val();
        if(citylabelval.indexOf('_') !== -1)
        {
          var citylabelvalsplit = citylabelval.split('_');
          citylabelval = citylabelvalsplit[1];
        }

        if (event.target.id == 'citylabel' && citylabelval != this.zipcodeold) {
          this.zipcodeold = citylabelval;
          this.zipcode = this.zipcodeold;
          this.streetcode = '';
          this.housenumber = '';
          this.housenumberextension = '';
          this.citycode = '';
        }

        if (event.target.id == 'consumptionlabel' || event.target.name == 'consumptionpicker'){
          this.consumption = this.consumptionlabel; // split automatisch durch v-model.number
          if(this.consumption == "" || isNaN(parseInt(this.consumption))) {
            this.consumptionlabel = '';
          }
          else if(typeof this.consumption === 'string' && this.consumption.includes('kWh')) {
            this.consumptionlabel = this.consumption;  
          }
          else {
            this.consumptionlabel = this.consumption + ' kWh';
          }
        }
      }

      if(!$('#continueToDelivery').attr("maintenance") && !this.isMaintenance) {
        $('#continueToDelivery').attr('disabled', true);
        if(this.consumption != '' && this.zipcode != '')
        {
          $('#continueToDelivery').attr('disabled', false);
        }
      }
      

      if(this.zipcode != '') $('#citylabel').parent('div').addClass('check');
      else $('#citylabel').parent('div').removeClass('check');

      if(this.consumptionlabel != '') $('#consumptionlabel').parent('div').addClass('check');
      else $('#consumptionlabel').parent('div').removeClass('check');

      if($('#housenumber').val() != '') $('#housenumber').parent('div').addClass('check');
      else $('#housenumber').parent('div').removeClass('check');

      if($('#housenumberextension').val() != '') $('#housenumberextension').parent('div').addClass('check');
      else $('#housenumberextension').parent('div').removeClass('check');

      if($('#streetcode').val() != '') $('#streetcode').parent('div').addClass('check');
      else $('#streetcode').parent('div').removeClass('check');

      if($('#citycode').val() != '') $('#citycode').parent('div').addClass('check');
      else $('#citycode').parent('div').removeClass('check');
      /*
       * Check kwH größer als 30.000
       */
      if(this.consumption > 30000)
      {
        $('#consumptionmsg').remove();
        // $('#msgcontainer').append('<div id="consumptionmsg" class="form-group alert alert-warning alert-dismissible hidden"> <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a>Vielen Dank für Ihr Interesse! Bei Ihrem Verbrauch möchten wir Ihnen gerne ein individuelles Angebot unterbreiten. Bitte schreiben Sie uns eine E-Mail an\n' +
        //     '      <a href="mailto:wohnungswirtschaft@dew21.de">wohnungswirtschaft@dew21.de</a>. Wir freuen uns auf Sie!</div>');
        // 22.12.2021 EB: Änderungen an Text
        $('#msgcontainer').append('<div id="consumptionmsg" class="form-group alert alert-warning alert-dismissible hidden"> <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a>Ihr Verbrauch liegt über 30.000 kWh. Sind Sie Geschäftskunde? Dann halten wir ein individuelles Angebot für Sie bereit.' + 
        'Senden Sie uns einfach Ihre Kontaktdaten an <a href="mailto:gewerbe@dew21.de?subject=Online-Tarifanfrage">gewerbe@dew21.de</a>. Wir melden uns dann umgehend bei Ihnen.<br>' +
        'Sind Sie Privatkunde? Dann klicken Sie auf „Tarif finden“.</div>');

        $('#consumptionmsg').removeClass('hidden');

        // this.$parent.loader(false);
      }
      else {
        $('#consumptionmsg').remove();
      }
    },
    checkcitylabel: function(event){
      if (event.target.id == 'citylabel') {
        this.streetcode = '';
        this.housenumber = '';
        this.housenumberextension = '';
        this.citycode = '';
        $('#streetcode').val('');
        $('#citycode').val('');

        if(typeof event.params.data != "undefined") this.zipcodepos = event.params.data.pos;

        // direkt abfragen ohne Buttonbestätigung
        this.continuetodelivery(false);
      }
    },
    citylabelcomplete: function(){
      this.submitAllowed = true;
    },
    setConsumption: function (event) {
      this.consumptionlabel = event.target.value;
      this.checkForm(event);
    },
    continuetodelivery: function(redirect = true) {
      // $('#consumptionmsg').addClass('hidden');

      if($('#streetcode').val() != '') this.streetcode = $('#streetcode').val();

      if($('#citycode').val() != '') this.citycode = $('#citycode').val();

      if (!this.submitAllowed) return false;
      this.continuetodeliverynew(redirect, this.zipcode, this.consumption, this.streetcode, this.housenumber, this.housenumberextension, this.citycode);
    },
    noCacheTimestamp: function() {
      return Date.now() + Math.floor((Math.random() * 99999999) + 1);
    },
    continuetodeliverynew: function(redirect = true, zipCode, consumption, streetCode = '', houseNumber = '', houseNumberExtension = '', cityCode = '') {
      /*
      Strom
      https://release.dew21.de/?type=5000&@c=Product&@a=getProducts&callback=jQuery31108806027487009926_1604322069427&division=10&postCode=44145&boilerOutput=11&consumption=2500&houseNumberExtension=&partnerType=01&date=01.12.2020&checked=false&campaignID=unset&noCacheTimestamp=1604409673276&_=1604322069431

      Erdgas
      https://release.dew21.de/?type=5000&@c=Product&@a=getProducts&callback=jQuery31108806027487009926_1604322069427&division=20&postCode=44145&boilerOutput=11&consumption=8000&houseNumberExtension=&partnerType=01&date=01.12.2020&checked=false&campaignID=unset&noCacheTimestamp=1604408582410&_=1604322069432
       */

       if(!consumption) {
        consumption = 1;
      }
      
      var tarifdate = moment().add(2, 'month').format('01.MM.YYYY'); // 01.12.2020
      var dewUrl = "/?type=5000&@c=Product&@a=getProducts&postCode="+ zipCode +"&consumption="+ consumption +"&streetCode=" + streetCode + "&houseNumber=" + houseNumber + "&houseNumberExtension=" + houseNumberExtension + '&cityCode=' + cityCode + "&division=20&partnerType=01&boilerOutput=11&date=" + tarifdate + "&checked=false&campaignID=unset";
      // ajax request

      var noCacheTimestamp = this.noCacheTimestamp();

      if(streetCode == '') $('#isMultiaddress').addClass('hidden');

      $.ajax({
        url: dewUrl + "&noCacheTimestamp="+ noCacheTimestamp,
        type: 'GET',
        dataType: 'jsonp',
        context: this,
        timeout: 15000,
        beforeSend: function () {
          this.$parent.loader(true);
        },
        success: function (resp) {
          var respObj = resp.data;

          if(typeof resp.data === 'undefined') {
            console.log('ERROR');
            console.log(resp);

            this.$parent.loader(false);
            this.maintenanceMessage = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.';
            this.isMaintenance = true;
          }
          else {

            if (settings.isMultiaddress && this.citycode != '' && this.streetcode != '') {
              settings.isMultiaddress = false;
            }

            // Multiple address
            settings.isMultiaddress = false;

            if (!respObj.isCityUnambiguous || !respObj.isDistributionNetworkOperatorUnambiguous) settings.isMultiaddress = true;

            if (settings.isMultiaddress) {
              this.$parent.loader(false);

              // suggestedCities
              // suggestedStreets

              /*
              * CITY
               */
              $('#isMultiaddress').removeClass('hidden');
              this.citycodes = respObj.suggestedCities.map(option => ({id: option.cityCode, text: option.cityName}));

              // Fokus auf Ort setzen
              $('#citycode').focus();

              if (this.citycodes.length == 1) {
                this.citycode = this.citycodes[0].id;
                $('#citycodemd').addClass('hidden');

                // Fokus auf Straße setzen
                $('#streetcode').focus();
              }

              /*
              * STREET
               */
              this.streetcode = '';

              if (respObj.isCityUnambiguous === true) {
                this.streetcodes = respObj.suggestedStreets.map(option => ({
                  id: option.streetCode,
                  text: option.streetName
                }));
              }

              this.submitAllowed = true;
            } else {
              var now = new Date();
              // 1 Woche in Sekunden
              var ttl = 604800;
              const item = {
                value: zipCode,
                expiry: now.getTime() + ttl,
              }
              window.localStorage.setItem('tarifrechnerStrom', JSON.stringify(item));

              const itemcity = {
                value: {
                  zipcode: zipCode,
                  zipcodepos: this.zipcodepos,
                  citycode: cityCode,
                  streetcode: streetCode,
                  houseNumber: houseNumber,
                  houseNumberExtension: houseNumberExtension
                },
                expiry: now.getTime() + ttl,
              }
              window.localStorage.setItem('tarifrechner', JSON.stringify(itemcity));

              if (redirect) this.redirect();
              else this.$parent.loader(false);
            }
          }
        },
        error: function (resp) {
          console.log('ERROR');
          console.log(resp);

          this.$parent.loader(false);
          this.maintenanceMessage = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.';
          this.isMaintenance = true;
        }
      });

    },


    redirect: function() {
      var desturl = this.defaultSettings.redirectgas + '?division=20' + ((this.salesSource) ? '&salesSource='+ this.salesSource : '') + '&partnerType=01&postCode=' + this.zipcode + '&consumption=' + this.consumption + '&streetCode=' + this.streetcode + '&cityCode=' + this.citycode + '&houseNumber=' + this.housenumber + '&houseNumberExtension=' + this.housenumberextension;
      window.location.href = desturl;
    },
  },
  components: { Selectbox, Selectboxajax }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
